import { Id } from '@shared/types/id';

export class SequenceSearchResult {
  constructor(
    readonly id: Id,
    readonly rid: string,
    readonly createdAt: Date,
    readonly program: string,
    readonly version: string,
    readonly queryId: string,
    readonly queryLength: number,
    readonly queryTitle: string,
    readonly reference: string,
    readonly database: string
  ) {}
}
